export default __webpack_public_path__ + "assets/img_other_object-d39a08d1.png";